import { StudyPlanTemplateModel } from '@/models/kingslanding/studyPlanTemplateModel';
import { MutationTree } from 'vuex';
import { StudyPlanState } from './state';
import Vue from 'vue';
import { AppointmentModel } from '@descomplica/dex-models';

const mutations: MutationTree<StudyPlanState> = {
  SET_STUDY_PLANS(state: StudyPlanState, payload: StudyPlanTemplateModel) {
    Vue.set(state.studyPlans, payload.id.toString(), {
      ...state.studyPlans[payload.id.toString()],
      ...payload,
    });
  },
  SET_CURRENT_STUDY_PLAN_DISPLAYED(state: StudyPlanState, payload: number) {
    state.currentStudyPlanDisplayed = payload.toString();
  },
  SET_IS_LOADING_COURSE_STUDY_PLAN(state: StudyPlanState, payload: boolean) {
    state.isLoadingStudyPlan = payload;
  },
  SET_CURRENT_WEEK(state: StudyPlanState, payload: number) {
    state.currentWeek = payload;
  },
  SET_LAST_PREVIOUS_WEEK_LOADED(state: StudyPlanState, payload: number) {
    state.lastPreviousWeekLoaded = payload;
  },
  SET_LAST_NEXT_WEEK_LOADED(state: StudyPlanState, payload: number) {
    state.lastNextWeekLoaded = payload;
  },
  SET_ACTIVITY_LOADED(state: StudyPlanState, payload: number) {
    state.loadedActivities = [...state.loadedActivities, payload];
  },
  DECREASE_PREVIOUS_WEEK_LOADED(state: StudyPlanState) {
    state.lastPreviousWeekLoaded -= 1;
  },
  INCREASE_NEXT_WEEK_LOADED(state: StudyPlanState) {
    state.lastNextWeekLoaded += 1;
  },
  SET_STUDY_PLAN_APPOINTMENTS(state, payload: { id: number; appointments: AppointmentModel[] }) {
    Vue.set(state.studyPlans, payload.id.toString(), {
      ...state.studyPlans[payload.id.toString()],
      appointments: [...payload.appointments],
    });
  },
};

export default mutations;
